
import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App.tsx'
import './index.css'

// Import mock places API for CSV import functionality
import '@/services/places/mockPlacesApi.ts'

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 60 * 1000, // 1 minute default
    },
  },
})

// Suppress Sentry errors from Lovable's monitoring script
window.addEventListener('error', (event) => {
  if (event.message && event.message.includes('sentry.io')) {
    console.warn('Sentry monitoring error suppressed:', event.message);
    event.preventDefault();
    return false;
  }
}, true);

window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && String(event.reason).includes('sentry.io')) {
    console.warn('Sentry monitoring promise rejection suppressed:', event.reason);
    event.preventDefault();
  }
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
)

// PWA service worker registration
const isInIframe = (() => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
})();

const isPreviewHost =
  window.location.hostname.includes("id-preview--") ||
  window.location.hostname.includes("lovableproject.com");

if (isPreviewHost || isInIframe) {
  navigator.serviceWorker?.getRegistrations().then((registrations) => {
    registrations.forEach((r) => r.unregister());
  });
} else {
  // @ts-ignore - virtual module from vite-plugin-pwa
  import('virtual:pwa-register').then(({ registerSW }) => {
    registerSW({ immediate: true });
  });
}
